import useVatInflowsTable from "./useVatInflowsTable";
import secondaryComponents from "..";

const VatInflowsTable = ({
  metaDetails,
  vatInflowData,
  selectedTab,
  gotoPage,
}) => {
  const { instance } = useVatInflowsTable({
    vatInflowData,
    selectedTab,
  });
  const { getTableBodyProps, getTableProps, headerGroups, rows, prepareRow } =
    instance;

  return (
    <>
      <secondaryComponents.TableHelper
        getTableBodyProps={getTableBodyProps}
        getTableProps={getTableProps}
        headerGroups={headerGroups}
        rows={rows}
        prepareRow={prepareRow}
        hasAction={true}
      >
        <h4 className="py-5 text-center">No Data Available</h4>
      </secondaryComponents.TableHelper>

      {/* pagination */}
      {vatInflowData?.length > 0 && (
        <div className="mt-auto">
          <secondaryComponents.Pagination
            totalPageNumber={metaDetails?.last_page}
            handlePageClick={(value) => gotoPage(value?.selected + 1)}
            currentPage={metaDetails?.current_page}
          />
        </div>
      )}
    </>
  );
};

export default VatInflowsTable;
